export const OPERATING_EXPENSE_DESTINATION = "Despesa operacional";

export const EXPENSE_CATEGORIES = [
	{ id: "bank_fee", name: "Tarifa" },
	{ id: "collaborators", name: "Colaboradores" },
	{ id: "electricity", name: "Energia elétrica" },
	{ id: "insurance", name: "Seguros" },
	{ id: "maintenance", name: "Manutenção" },
	{ id: "software_services", name: "Software e serviços digitais" },
	{ id: "forklift_gas", name: "Gás de empilhadeira" },
] as const;

export type ExpenseCategoryId = (typeof EXPENSE_CATEGORIES)[number]["id"];

interface OperatingExpenseTransaction {
	id: string;
	description: string;
	amountCents: number;
	occurredOn: string;
	direction: "DEBIT" | "CREDIT";
	bankStatus: "POSTED" | "PENDING";
	classification: {
		destination: string;
		expenseCategory: { id: string; name: string } | null;
	} | null;
}

export const OperatingExpenses = {
	list<Transaction extends OperatingExpenseTransaction>(transactions: Transaction[]) {
		return transactions.filter(
			(transaction) =>
				transaction.direction === "DEBIT" &&
				transaction.bankStatus === "POSTED" &&
				transaction.classification?.destination === OPERATING_EXPENSE_DESTINATION &&
				transaction.classification.expenseCategory,
		);
	},

	summarize(transactions: OperatingExpenseTransaction[]) {
		const categories = new Map<
			string,
			{ id: string; name: string; transactionCount: number; amountCents: number }
		>();

		for (const transaction of this.list(transactions)) {
			const category = transaction.classification?.expenseCategory;

			if (!category) {
				continue;
			}

			const current = categories.get(category.id);

			categories.set(category.id, {
				id: category.id,
				name: category.name,
				transactionCount: (current?.transactionCount ?? 0) + 1,
				amountCents: (current?.amountCents ?? 0) + Math.abs(transaction.amountCents),
			});
		}

		return [...categories.values()].toSorted((left, right) => right.amountCents - left.amountCents);
	},
};
